module.exports = __webpack_public_path__ + "img/ic-speedometer-2.9c128d8b.png";